import { FirebaseDocRefType, FirebaseDocumentDataType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { fetchSchedulesAction } from 'reducks/schedule/actions'
import { mergeSchedules } from 'reducks/schedule/operations'

const fetchSchedules = (storeRef: FirebaseDocRefType, types?: Array<'preorder' | 'daily' | 'shared'>) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const manufacturerRef = getState().auth.manufacturer_ref

    let query =
      typeof types !== 'undefined'
        ? storeRef.collection('store_schedules').where('type', 'in', types)
        : storeRef.collection('store_schedules')

    if (typeof manufacturerRef !== 'undefined') {
      query = query.where('manufacturer_ref', '==', manufacturerRef)
    }

    const schedules = await query
      .orderBy('bread_ref', 'asc')
      .get()
      .then((snapshots: FirebaseDocumentDataType) => {
        return mergeSchedules(snapshots)
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    dispatch(fetchSchedulesAction(schedules))
  }
}

export default fetchSchedules
